import { render, staticRenderFns } from "./IncidentReportCPSBox.vue?vue&type=template&id=f8e79f5c&"
import script from "./IncidentReportCPSBox.vue?vue&type=script&lang=js&"
export * from "./IncidentReportCPSBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports